import type { AdditionalCoveragesDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto';
import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { useRecoilValue } from 'recoil';
import { getOnsaCurrentProductSelector } from '../selectors/getOnsaCurrentProductSelector';
import { isLoggedOnSelector } from '../selectors/isLoggedOnSelector';
import { jobInfoAtom } from '../atoms/jobInfoAtom';

export function useCalculateCoveragesPrice(): {
    calculateCoveragesPrice: () => Promise<AdditionalCoveragesDTO>;
} {
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);
    const { fixedId, lobCode } = useRecoilValue(getOnsaCurrentProductSelector);

    if (!jobNumber) throw new Error('Invalid jobNumber');
    if (!sessionId) throw new Error('Invalid sessionId');
    if (!lobCode) throw new Error('Invalid lobCode');
    if (!fixedId) throw new Error('Invalid coverableFixedId');
    const isLoggedOn = useRecoilValue(isLoggedOnSelector);

    const calculateCoveragesPrice = async (): Promise<AdditionalCoveragesDTO> => {
        return await OnlineSalesUnauthenticated.calculateCoveragesPrice(
            jobNumber,
            lobCode,
            fixedId,
            sessionId,
            !isLoggedOn
        );
    };

    return { calculateCoveragesPrice };
}
